import { render, staticRenderFns } from "./a404.vue?vue&type=template&id=297733b2&scoped=true"
import script from "./a404.vue?vue&type=script&lang=js"
export * from "./a404.vue?vue&type=script&lang=js"
import style0 from "./a404.vue?vue&type=style&index=0&id=297733b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297733b2",
  null
  
)

export default component.exports